var map = {
	"./adaptiveMenu.svg": 78178,
	"./advancedMath.svg": 3597,
	"./alisaTheater.svg": 9198,
	"./arrowDown.svg": 47340,
	"./arrowLeft.svg": 62055,
	"./arrowLinedDown.svg": 97729,
	"./arrowLinedLeft.svg": 41293,
	"./arrowLinedRight.svg": 21112,
	"./arrowLinedUp.svg": 26556,
	"./arrowRight.svg": 62387,
	"./arrowRoundDown.svg": 72154,
	"./arrowRoundDownSmall.svg": 60018,
	"./arrowRoundLeft.svg": 34721,
	"./arrowRoundLeftSmall.svg": 96392,
	"./arrowRoundRight.svg": 59894,
	"./arrowRoundRightSmall.svg": 90290,
	"./arrowRoundUp.svg": 44627,
	"./arrowRoundUpSmall.svg": 76975,
	"./arrowUp.svg": 71395,
	"./award.svg": 44882,
	"./back.svg": 85602,
	"./bio.svg": 47379,
	"./blocknote.svg": 72774,
	"./calendar.svg": 84142,
	"./cardAvailable.svg": 1566,
	"./cardLocked.svg": 68311,
	"./cardPassed.svg": 8801,
	"./cards.svg": 46954,
	"./check.svg": 53646,
	"./checkBig.svg": 41304,
	"./chem.svg": 99078,
	"./clock.svg": 16558,
	"./close.svg": 79731,
	"./coin.svg": 93601,
	"./completedCard.svg": 49766,
	"./compress.svg": 29479,
	"./cup.svg": 99564,
	"./daily.svg": 35914,
	"./darts.svg": 41848,
	"./diplom.svg": 7427,
	"./distantLessons.svg": 10858,
	"./down.svg": 93136,
	"./download.svg": 98969,
	"./edit.svg": 76383,
	"./eng.svg": 51976,
	"./envi.svg": 9468,
	"./expand.svg": 11138,
	"./files.svg": 81726,
	"./fin.svg": 6302,
	"./gamepad.svg": 74148,
	"./geo.svg": 94419,
	"./gift.svg": 24262,
	"./hat.svg": 7222,
	"./hist.svg": 75287,
	"./list.svg": 9240,
	"./listDown.svg": 10313,
	"./listUp.svg": 93848,
	"./lock.svg": 15273,
	"./lockBig.svg": 15852,
	"./math.svg": 89163,
	"./minus.svg": 1573,
	"./onlineLessons.svg": 11312,
	"./openedMenu.svg": 54522,
	"./phys.svg": 3333,
	"./play.svg": 74937,
	"./plus.svg": 9968,
	"./print.svg": 91438,
	"./prog.svg": 92661,
	"./puzzle.svg": 66722,
	"./question.svg": 33,
	"./reactivateCards.svg": 81680,
	"./rocket.svg": 95564,
	"./rus.svg": 82122,
	"./safe.svg": 72013,
	"./soc.svg": 28515,
	"./starDone.svg": 42429,
	"./starEmpty.svg": 46351,
	"./timer.svg": 62202,
	"./tv.svg": 21068,
	"./users.svg": 86091,
	"./vpr.svg": 21573,
	"./wardrobe.svg": 21981,
	"./warning.svg": 38955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58612;